/* eslint-disable no-underscore-dangle */
import { Immutable } from '@zervant/reactcomponents'
import { CompanyInterface, VatNumberValidation } from 'client/Interfaces/CompanyInterface'
import { StateInterface } from 'client/Interfaces/StateInterface'

import { ReducerBuilder } from './ReducerBuilder'

export const INITIAL_STATE: CompanyInterface = {
  country: null,
  businessId: null,
}

type StateType = CompanyInterface | null
type PayloadType = CompanyInterface

function _assignCompany(state: StateType, payload: PayloadType): StateType {
  return Immutable.copy(payload)
}

function _assignLocale(state: StateType, payload: string): StateType {
  const newState = Immutable.copy(state)
  newState.locale = payload
  return newState
}

function _updateVatNumberValidation(state: StateType, payload: VatNumberValidation): StateType {
  if (state?.vatNumberValidation) {
    const newState = Immutable.copy(state)
    newState.vatNumberValidation = payload
    return newState
  }
  return state
}

export default new ReducerBuilder<StateType, PayloadType | string>(INITIAL_STATE)
  .mapAction('GET_COMPANY', _assignCompany)
  .mapAction('COMPANY_UPDATE', _assignCompany)
  .mapAction('COMPANY_UPDATE_VAT_NUMBER', _assignCompany)
  .mapAction('COMPANY_UPDATE_INVOICING_PROFILE', _assignCompany)
  .mapAction('INITIALIZE_COMPANY', _assignCompany)
  .mapAction('CHANGE_LOCALE', _assignLocale)
  .mapAction('UPDATE_VAT_NUMBER_VALIDATION', _updateVatNumberValidation)
  .build()

export const companySelector = (state: StateInterface): CompanyInterface => state.company
